import { RECEIVE_ASSESSMENT } from '../../actions/appActions';

const assessmentReducer = (state = {}, action) => {
    Object.freeze(state);

    switch (action.type) {
        case RECEIVE_ASSESSMENT:
            return parseAssessmentInfo(action.assessment);

        default:
            return state;
    }
};

const parseAssessmentInfo = assessment => {
    return {
        version: assessment.version,
        name: assessment.name,
        internalName: assessment.internalName,
        id: assessment.documentId,
        type: assessment.type,
        rootPrompt: assessment.rootPrompt,
        tabTitle: assessment.tabTitle,
        countryRestriction: assessment.countryRestriction,
        loadingConfig: assessment.loadingConfig,
        resultsConfig: assessment.resultsConfig,
        inlineConfig: assessment.inlineConfig,
        introConfig: assessment.introConfig,
        eventConfig: assessment.eventConfig,
        condition: assessment.condition,
        privacyPolicyUrl: assessment.privacyPolicyUrl,
        sponsorImageUrl: assessment.sponsorImageUrl,
        sponsorUrl: assessment.sponsorUrl,
        site: assessment.site
    };
};

export default assessmentReducer;
